/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function ErrorMessageAlert({ errorInfo, open, handleClose }) {
  function getMessageFromErrorInfo(errorInfo) {
    console.log("ErrorInfo Object : " , errorInfo)
    let message = "";
    if (
      errorInfo &&
      errorInfo.response &&
      errorInfo.response.request &&
      errorInfo.response.request.response
    ) {
      message = JSON.parse(errorInfo.response.request.response).message;
      //when there are multiple errors message will be null and messages will be coming under errors array.
      if (message === null) {
        message = "";
        let errors = JSON.parse(errorInfo.response.request.response).errors;
        if (Array.isArray(errors)) {
          errors.forEach((errObj) => {
            message = message.concat(errObj.message);
          });
        }
      }
    }
    return message;
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Error</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorInfo ? errorInfo.message : ""}
          </DialogContentText>

          <p>{getMessageFromErrorInfo(errorInfo)}</p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              console.log("close");
              handleClose();
            }}
            color="secondary"
          >
            close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
